






















import { listFactory } from '@/main/pages/listFactory';
import { TabulkovaPozice } from '@/modules/ciselnik/dilenske/tabulkovaPozice';
import { listMutations } from '@/modules/ciselnik/dilenske/servisniPakety/store/types';

import { NAME } from './constants';
import { store } from './store/list';

export default listFactory(NAME, store).extend({
	components: {
		TabulkovaPoziceSelect: TabulkovaPozice.components.Select,
	},
	computed: {
		mutationsMappers(): Record<string, string> {
			return {
				tabulkovaPozice: `${this.storeUri}/${listMutations.TABULKOVA_POZICE_SELECT_MAPPER}`,
			};
		},
	},
});
